/**
 * TrendMart AJAX Collection & Facet Filtering Controller
 * Powered by Shopify Search & Discovery and Section Rendering API
 */
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-collection-container]');
  if (!container) return;

  const sectionId = container.getAttribute('data-section-id');

  const setupDesktopToggle = () => {
    const toggleBtn = container.querySelector('[data-filter-toggle]');
    const layout = container.querySelector('[data-layout-container]');
    if (toggleBtn && layout) {
      toggleBtn.addEventListener('click', () => {
        layout.classList.toggle('is-filters-hidden');
      });
    }
  };

  const setupMobileDrawer = () => {
    const filterDrawer = container.querySelector('[data-filter-drawer]');
    const drawerBackdrop = container.querySelector('[data-mobile-filter-backdrop]');
    const openBtn = container.querySelector('[data-mobile-filter-open]');
    const closeBtn = container.querySelector('[data-mobile-filter-close]');

    if (openBtn && filterDrawer) {
      openBtn.addEventListener('click', () => {
        filterDrawer.classList.add('is-open');
        if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    const closeDrawer = () => {
      if (filterDrawer) filterDrawer.classList.remove('is-open');
      if (drawerBackdrop) drawerBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);
  };

  const renderSection = (url) => {
    container.style.opacity = '0.6';
    container.style.pointerEvents = 'none';

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContent = doc.querySelector('[data-collection-content]');
        const oldContent = container.querySelector('[data-collection-content]');
        if (newContent && oldContent) oldContent.innerHTML = newContent.innerHTML;

        const newFilters = doc.querySelector('[data-facet-filters]');
        const oldFilters = container.querySelector('[data-facet-filters]');
        if (newFilters && oldFilters) oldFilters.innerHTML = newFilters.innerHTML;

        const newCount = doc.querySelector('[data-product-count]');
        const oldCount = container.querySelector('[data-product-count]');
        if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;

        // Re-bind events on new filters & content
        bindFilterEvents();
        setupMobileDrawer();
        setupDesktopToggle();

        // Dispatch event for mini-options or wishlist scripts to re-bind
        document.dispatchEvent(new CustomEvent('collection:updated', { detail: { container } }));
      })
      .catch(err => {
        console.error('Filtering error:', err);
      })
      .finally(() => {
        container.style.opacity = '1';
        container.style.pointerEvents = '';
      });
  };

  const updateFilters = (e) => {
    const currentForm = container.querySelector('[data-filter-form]');
    if (!currentForm) return;

    const formData = new FormData(currentForm);
    const searchParams = new URLSearchParams(formData);

    // Remove empty params
    const keysToRemove = [];
    searchParams.forEach((val, key) => {
      if (!val) keysToRemove.push(key);
    });
    keysToRemove.forEach(k => searchParams.delete(k));

    let sortVal = '';
    if (e && e.target && e.target.hasAttribute('data-sort-by')) {
      sortVal = e.target.value;
    } else {
      const activeSort = container.querySelector('[data-sort-by]');
      if (activeSort) sortVal = activeSort.value;
    }
    if (sortVal) {
      searchParams.set('sort_by', sortVal);
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);

    renderSection(`${newUrl}&section_id=${sectionId}`);
  };

  const bindFilterEvents = () => {
    const currentForm = container.querySelector('[data-filter-form]');
    if (currentForm) {
      // Checkboxes
      currentForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.addEventListener('change', updateFilters);
      });

      // Price range with debounce
      currentForm.querySelectorAll('input[type="number"]').forEach(input => {
        if (window.TrendMart && TrendMart.utils && TrendMart.utils.debounce) {
          input.addEventListener('input', TrendMart.utils.debounce(updateFilters, 500));
        } else {
          input.addEventListener('change', updateFilters);
        }
      });
    }

    // Sort selects (desktop & mobile)
    container.querySelectorAll('[data-sort-by]').forEach(select => {
      select.removeEventListener('change', updateFilters);
      select.addEventListener('change', updateFilters);
    });

    // Clear all filters
    container.querySelectorAll('[data-clear-all-filters]').forEach(clearBtn => {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.history.pushState({}, '', window.location.pathname);
        renderSection(`${window.location.pathname}?section_id=${sectionId}`);
      });
    });

    // Active facet pill removal
    container.querySelectorAll('[data-facet-remove]').forEach(removeLink => {
      removeLink.addEventListener('click', (e) => {
        e.preventDefault();
        const targetHref = removeLink.getAttribute('href');
        if (targetHref) {
          window.history.pushState({}, '', targetHref);
          renderSection(`${targetHref}&section_id=${sectionId}`);
        }
      });
    });
  };

  // Handle browser back/forward
  window.addEventListener('popstate', () => {
    renderSection(`${window.location.href}&section_id=${sectionId}`);
  });

  bindFilterEvents();
  setupMobileDrawer();
  setupDesktopToggle();
});
